/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  AddTradingChallengeUsersOptions,
  AddTradingChallengeUsersResponses,
} from '../types/AddTradingChallengeUsers'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Add existing users to a trading challenge. For COMPETITION_MANAGER, the challenge must be assigned in managed_competition_ids. A user must have an empty ledger to join: deposits and withdrawals are barred from enrolment until the challenge is over, so that challenge credits are the only thing a participant holds and the teardown sweep cannot destroy funds of their own.
 * @summary Add users to a trading challenge
 * {@link /v1/trading_challenges/add_users}
 */
export function addTradingChallengeUsers<ThrowOnError extends boolean = true>(
  options: Options<AddTradingChallengeUsersOptions, ThrowOnError>,
): Unwrappable<RequestResult<AddTradingChallengeUsersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/trading_challenges/add_users',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<AddTradingChallengeUsersResponses, ThrowOnError>>,
  )
}
